<template>
  <div class="index">
    <Header></Header>
    <hr/>
    <div :class="{'main-bg': theme === 'dark'}">
      <el-tabs v-model="activeName" type="card" class="con-tab index-tab" :before-leave='leaveTab'>
        <el-tab-pane :label="$t('T_SIMPLE_MODE')" name="Basic"></el-tab-pane>
        <el-tab-pane :label="$t('T_ADVANCED_MODE')" name="Advanced">
      </el-tab-pane>
      </el-tabs>
      <div>
        <SearchTab></SearchTab>
        <div class="clear"></div>
      </div>
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<script>
import Header from '../components/header'
import SearchTab from '../components/searchTab'
import Condition from '../view/condition/condition'
import Sideview from '../view/graph/sideView'
import Frontview from '../view/graph/frontView'
import Topview from '../view/graph/topView'
import ThreeDview from '../view/graph/threeDView'
import USTview from '../view/graph/UST/USTViewIndex'
import Resultinformation from '../view/result/resultInformation'
import SimpleViewIndex from '../view/graph/Simple/simpleViewIndex'
import Footer from '../components/footer'
import ResizePanel from '@/components/resizePanel'
import { mapState, mapMutations } from 'vuex'
import Vue from 'vue'
export default {
  name: 'index',
  components: {
    Header,
    SearchTab,
    Condition,
    Sideview,
    Frontview,
    Topview,
    ThreeDview,
    USTview,
    Resultinformation,
    SimpleViewIndex,
    Footer,
    ResizePanel
  },
  data () {
    return {
    }
  },
  created () {
    let ur = this.$route.path
    // if (this.InitConfig.initMain === 1) {
    this.SET_LANGUAGEDEFAULT(this.languageDefault)
    this.SET_UNIT(this.initConfig.initUnit === '' ? 'T_METRE_M' : this.initConfig.initUnit)
    this.SET_BLENDINGUNIT(this.initConfig.initUnit === '' ? 'T_METRE_M' : this.initConfig.initUnit)
    // }
    if (ur === '/page/basicMode') {
      this.$router.push('/page/basicMode')
      this.activeName = 'Basic'
    } else if (ur === '/page/advanceMode') {
      this.$router.push('/page/advanceMode')
      this.activeName = 'Advanced'
    }
    this.$i18n.locale = this.languageDefault
    sessionStorage.setItem('reload', true)
    this.SET_LANGUAGEFLAG(true)
    this.SPECIFICATIONMATCHINGMODELDATA(this.ProjectorSpec)
    this.INSTALLMATCHINGMODELDATA(this.ProjectorSpec)
    this.SEARCHMATCHINGMODELDATA(this.ProjectorSpec)
    this.SEARCHSELECTEDMODELDATA(this.ProjectorSpec[0])
    this.MATCHINGMODELDATA(this.ProjectorSpec)
    this.SELECTEDMODELDATA(this.ProjectorSpec[0])
  },
  methods: {
    ...mapMutations([ 'SET_REALTHROWDISTANCECHECKED', 'SET_SCREENSIZECHECKED', 'SET_THROWDISTANCECHECKED', 'SET_VLENSSHIFT', 'SET_HLENSSHIFT', 'SET_OFFSET',
      'SET_HANGLEFLAG', 'SET_VANGLEFLAG', 'SPECIFICATIONMATCHINGMODELDATA', 'INSTALLMATCHINGMODELDATA', 'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'SET_BROWSERTYPE',
      'SET_UNIT', 'SET_BLENDINGUNIT', 'SET_LANGUAGEDEFAULT', 'SET_ISSIMPLE', 'SET_TABACTIVENAME', 'ROOMW', 'ROOMD', 'ROOMH', 'SET_FROMBLENDING', 'SET_OUTOFSPECVAL',
      'SET_ISOUTOFSPEC', 'SET_LANGUAGEFLAG', 'SET_ISHISTORYROWCLICK' ]),
    leaveTab (active, oldActive) {
      let isUstNotWallToSimple = false
      let isUstWallToAdvance = false
      this.SET_FROMBLENDING(false)
      if (oldActive === 'Advanced' && (this.searchTabActive === 'Blending' || this.searchTabActive === 'CurvedSurface')) {
        return false
      } else if ((this.selectedModelData.category === 4 || this.selectedModelData.category === 5) && this.position === 2 && active === 'Basic') {
        return false
      }
      if (active === 'Basic') {
        this.$router.push('/page/basicMode')
        this.SET_ISSIMPLE(true)
      } else {
        this.$router.push('/page/advanceMode')
        this.SET_ISSIMPLE(false)
      }
      if ((this.selectedModelData.category === 4 || this.selectedModelData.category === 5) && this.position !== 2 && active === 'Basic') {
        isUstNotWallToSimple = true
      }
      if ((this.selectedModelData.category === 4 || this.selectedModelData.category === 5) && this.position === 2 && active === 'Advanced') {
        isUstWallToAdvance = true
      }
      if (!this.isHistoryRowClick) {
        this.$commonJs.SimpleDisable(isUstNotWallToSimple, isUstWallToAdvance)
      }
    },
    activeRouter () {
      if (this.activeName === 'Basic') {
        this.$router.push('/page/basicMode').catch(err => err)
        this.SET_ISSIMPLE(true)
      } else {
        this.$router.push('/page/advanceMode').catch(err => err)
        this.SET_ISSIMPLE(false)
      }
    }
  },

  mounted () {
    this.activeRouter()
  },

  computed: {
    ...mapState([
      'theme', 'isUSTWall', 'languageDefault', 'selectedModelData', 'position',
      'isSimple', 'tabActiveName', 'houseInfo', 'searchTabActive', 'isHistoryRowClick'
    ]),
    roomH () {
      return this.houseInfo.roomH
    },
    initConfig () {
      return Vue.prototype.InitConfig
    },
    activeName: {
      get () {
        return this.tabActiveName
      },
      set (val) {
        this.SET_TABACTIVENAME(val)
      }
    }
  }
}

</script>

<style scoped>
.index-tab {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue